import Product from '@common/models/Product';
import Variant from '@common/models/Variant';
import { addProductToCart, subtractProductFromCart } from '@common/store/cart/slice';
import Minus from '@images/Minus.svg';
import Plus from '@images/Plus.svg';
import Button from '@lib/Button';
import classnames from 'classnames';
import React, { useState } from 'react';

interface StepperProps {
  index?: number;
  product: Product | Variant;
  subtractProductFromCart: typeof subtractProductFromCart;
  addProductToCart: typeof addProductToCart;
  quantity: number;
  cartProductQuantity: number;
  isSmallerVariant?: boolean;
  className?: string;
  inputClassName?: string;
  isBiggerVariant?: boolean;
  alterCoupon?: () => void;
}

const Stepper: React.FC<StepperProps> = ({
  index,
  className = '',
  product,
  subtractProductFromCart,
  addProductToCart,
  quantity,
  isSmallerVariant,
  isBiggerVariant,
  alterCoupon,
  inputClassName,
  cartProductQuantity,
}) => {
  const [disabled, setdisabled] = useState(null);
  return (
    <div
      className={classnames(
        'inline-flex justify-center rounded flex-no-wrap items-center border-2 border-theme',
        className,
      )}
      font-customisation="para-text"
    >
      <Button
        className={classnames(
          'font-bold no-defaults h-44 w-30 text-22 text-theme bg-disabled rounded focus:outline-none disabled:text-gray disabled:cursor-not-allowed',
        )}
        onClick={(e) => {
          setdisabled('minus');
          e.preventDefault();
          subtractProductFromCart({ product });
          alterCoupon();
          setTimeout(() => {
            setdisabled(null);
          }, 250);
        }}
        disabled={disabled === 'minus'}
        id={'cart-quantity-decrement-' + (index + 1)}
      >
        <span className="-mt-4">
          <img src={Minus} alt="minus" className="mx-auto" />
        </span>
      </Button>
      <input
        readOnly
        type="text"
        className={classnames(
          'text-center bg-white text-18 focus:outline-none font-bold',
          {
            'rounded h-44 w-40 text-theme ': isSmallerVariant,
            'rounded h-44 w-48 text-theme': !isSmallerVariant && !isBiggerVariant,
            'rounded h-44 max-w-140': isBiggerVariant,
          },
          inputClassName,
        )}
        value={quantity}
        onClick={(e) => {
          e.preventDefault();
        }}
        color-customisation="page-body-text"
      />
      <Button
        className={classnames(
          'font-bold no-defaults h-44 w-30 text-22 text-theme bg-disabled rounded focus:outline-none disabled:text-gray disabled:cursor-not-allowed',
        )}
        onClick={(e) => {
          setdisabled('plus');
          e.preventDefault();
          addProductToCart({ product, disableSuccessToasts: true });
          alterCoupon();
          setTimeout(() => {
            setdisabled(null);
          }, 250);
        }}
        disabled={cartProductQuantity >= Math.min(product.stock, product.maxQuantity) || disabled === 'plus'}
        id={'cart-quantity-increment-' + (index + 1)}
      >
        <span>
          <img src={Plus} alt="plus" className="mx-auto" />
        </span>
      </Button>
    </div>
  );
};

export default Stepper;
